import styled from "@emotion/styled";

import { BaseEntityLink } from "shared/components/common/base-entity-link";
import { fontRobotoCondensed, theme } from "shared/lib/styles";

export const Container = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template:
    "section more" min-content
    "section others" 1fr;
  grid-template-columns: auto auto;
  grid-gap: 24px 31px;

  font-family: ${fontRobotoCondensed};

  ${theme.breakpoints.up("tablet")} {
    grid-template: "section more others";
    grid-column-gap: 48px;
  }

  ${theme.breakpoints.up("mediumDesktop")} {
    grid-column-gap: 72px;
  }
`;

const MenuContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-rows: min-content max-content;
  grid-row-gap: 24px;

  ${theme.breakpoints.only("mobile")} {
    min-inline-size: 132px;
  }

  ${theme.breakpoints.up("tablet")} {
    grid-row-gap: 16px;
  }
`;

export const MenuSectionContainer = styled(MenuContainer)`
  grid-area: section;
`;

export const MenuMoreContainer = styled(MenuContainer)`
  grid-area: more;
`;

export const MenuOthersContainer = styled(MenuContainer)`
  grid-area: others;
`;

export const MenuItemLabel = styled.div`
  color: #a1a1a1;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: -0.014px;
  text-transform: uppercase;
`;

export const MenuLinkContainer = styled.div`
  display: grid;
  grid-row-gap: 12px;

  ${theme.breakpoints.up("tablet")} {
    grid-auto-flow: column;
    grid-template-rows: min-content min-content;
    grid-gap: 10px 72px;
  }
`;

export const MenuSectionLinkContainer = styled.div`
  display: grid;
  grid-template-columns: auto;
  grid-row-gap: 12px;

  ${theme.breakpoints.up("tablet")} {
    grid-row-gap: 10px;
  }

  ${theme.breakpoints.up("desktop")} {
    grid-template-columns: max-content max-content max-content;
    grid-column-gap: 48px;
  }

  ${theme.breakpoints.up("mediumDesktop")} {
    grid-column-gap: 72px;
  }
`;

export const Anchor = styled.a`
  color: #ffffff;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: -0.014px;
  text-transform: uppercase;
`;

export const StyledBaseEntityLink = styled(BaseEntityLink)`
  color: #ffffff;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: -0.014px;
  text-transform: uppercase;

  &::before {
    position: relative;
    content: "//";

    margin-inline-end: 4px;
  }
`;
